import { LanguageSchema } from "@/assets/lang";

const it: LanguageSchema = {
  "title": "Polpo",
  "button": {
    "cancel": "Annullamento",
    "ok": "OK",
    "discardChanges": "Rifiuta le modifiche",
    "search": "Sfogliare",
    "confirm": "Confermare",
    "choose": "Seleziona",
    "forward": "Avanti",
    "back": "Indietro",
    "reset": "Indietro",
    "apply": "Applicare",
    "login": "Accedi",
    "logout": "Esci dal sito",
    "send": "Invia",
    "backToStart": "Torna all'inizio",
    "backToLogin": "Torna al login",
    "no": "No",
    "yes": "Sì",
    "toPayment": "Per il pagamento",
    "finishOrder": "Effettuare l'ordine",
    "thank": "Ringraziamento",
    "sendInvite": "Inviare l'invito",
    "resend": "Reinvia l'invito",
    "startNow": "Iniziare ora",
    "skip": "Salta",
    "register": "Registrati ora",
    "registerNoCode": "Registrati senza codice",
    "save": "Risparmia",
    "saveChanges": "Applica le modifiche",
    "delete": "{target} eliminare",
    "addCart": "Aggiungi l'elenco al carrello",
    "orderNow": "Ordina ora",
    "add": "Aggiungi a",
    "changePassword": "Cambia password",
    "changeLogin": "Modifica dei dati di accesso",
    "changeEmail": "Modifica dell'e-mail",
    "edit": "Modifica",
    "share": "Condividi",
    "delivererNotFound": "Fornitore non trovato?",
    "joinLocation": "Entrare nel team",
    "createLocation": "Creare una sede",
    "editSupplier": "Fornitore @.lower:button.edit",
    "create": "Creare",
    "deleteSupplier": "Eliminare il fornitore",
    "forwardApp": "Vai all'app",
    "endIntro": "Terminare l'introduzione",
    "upload": "Caricare",
    "showMore": "Mostra di più",
    "hide": "nascondersi",
    "deleteAll": "Cancellare tutti",
    "settings": "Impostazioni",
    "manualSort": "Modifica dell'ordinamento manuale",
    "switchOldVersion": "Alla vecchia versione",
    "goToAppVersion": "Utilizzare Octopus nel browser",
    "updateList": "Aggiungi all'elenco",
    "updateCart": "Aggiungi al carrello",
    "openCameraScanner": "Scanner a telecamera aperta",
    "orderOverview": "Alla panoramica degli ordini",
    "deleteSupplierCart": "Cancellare il carrello della spesa",
    "resetAmount": "Azzeramento delle quantità dei prodotti",
    "requestAiCall": "Richiesta di chiamata AI",
    "filter": {
      "all": "Tutto",
      "promotion": "Azioni",
      "productSuggestion": "Ispirazioni"
    }
  },
  "input": {
    "text": "Testo",
    "password": "Password | Password",
    "email": "Email",
    "number": "Numero di telefono",
    "url": "Collegamento",
    "tel": "Telefono",
    "search": "Ricerca",
    "date": "Data",
    "orderDate": "Data dell'ordine",
    "datetime": "Data",
    "datetime-local": "Ora locale",
    "month": "Mese",
    "week": "Settimana",
    "time": "Tempo",
    "range": "Scala",
    "color": "Colore"
  },
  "table": {
    "empty": "La tabella non seleziona gli elementi"
  },
  "label": {
    "confirm": "conferma",
    "pwConfirm": "@:input.password @:label.confirm",
    "newReminder": "Aggiungi un nuovo allarme ordine",
    "selectPlaceholder": "Selezionare",
    "orderHint": "Nota del fornitore",
    "selectTitle": "Selezionare",
    "date": "@:input.date",
    "time": "Tempo",
    "dateTime": "@:label.date e @:label.time",
    "sum": "Totale",
    "orderDetails": "Dettagli della fattura",
    "promoCode": "Codice coupon",
    "orderNumber": "Numero d'ordine",
    "octopusId": "ID polpo",
    "orderMessage": "Messaggio dell'ordine",
    "description": "Descrizione",
    "sort": "Ordinamento",
    "priceRange": "Fascia di prezzo",
    "login": "Effettua il login",
    "user": "Utente",
    "newEmail": "Nuova e-mail",
    "oldPassword": "Vecchio @:input.password",
    "password": "@:input.password",
    "pwForget": "@:input.password dimenticato",
    "contactData": "Dettagli del contatto",
    "name": "Nome e cognome",
    "list": "Elenco",
    "type": "Tipo",
    "zip": "CAP",
    "city": "Città",
    "street": "Indirizzo",
    "streetNumber": "Numero civico",
    "phone": "Telefono",
    "fax": "Fax",
    "streetName": "Nome della strada",
    "postalCode": "@:label.zip",
    "deliverer": "@:object.deliverer",
    "customerNumber": "Numero del cliente/numero del luogo di acquisto",
    "quickstart": "Codice di avvio rapido",
    "email": "@:input.email",
    "firstName": "Primo nome",
    "lastName": "Nome e cognome",
    "dark": "Colore scuro",
    "light": "Luce",
    "standard": "Impostazione del sistema",
    "amount": "Quantità",
    "multipleAmount": "la quantità deve essere un multiplo di {target}",
    "maxAmount": "Articolo massimo {target}",
    "standardList": "Elenco standard",
    "language": "Lingua",
    "aiCallLanguage": "Lingua di chiamata",
    "oldMessages": "Notizie più vecchie",
    "notification": {
      "allow": "Consenti messaggi"
    },
    "permission": {
      "order": "@:object.order",
      "promotion": "@:oggetto.promozione",
      "message": "@:oggetto.messaggio",
      "news": "Notizie",
      "reminder": "Promemoria per gli ordini",
      "productPromotion": "Suggerimenti sui prodotti",
      "sub": {
        "newOrder": "Nuovi ordini",
        "updateStatus": "Aggiornamento ordini",
        "added": "Nuova promozione",
        "ending": "Promozione a",
        "general": "Generale"
      },
      "mode": {
        "push": "Messaggio push",
        "email": "Notifica via e-mail",
        "popup": "Popup"
      }
    },
    "teamRole": {
      "admin": "Amministrazione",
      "user": "Membro del team Pro",
      "device": "Membro del team base",
      "OWNER": "Proprietario"
    },
    "teamRoleShort": {
      "admin": "Amministratore",
      "user": "Pro",
      "device": "Base",
      "OWNER": "Proprietario"
    },
    "support": {
      "general": "Supporto Octopus",
      "gastro": "Team Servizio Clienti Gastro",
      "technical": "Servizio tecnico clienti del team",
      "technicalLead": "Leader tecnico",
      "distribution": "Firmatario autorizzato, marketing, vendite",
      "service": "Team Servizio Clienti"
    },
    "loading": {
      "location": "Caricamento @:object.location"
    },
    "onAccount": "Fattura",
    "onAccountOrCash": "Fattura o contanti",
    "ON_ACCOUNT": "@:label.onAccount",
    "UNSPECIFIED": "non specificato",
    "CASH": "@:label.cash",
    "cash": "Bar",
    "bar": "Bar / pub",
    "office": "Ufficio",
    "coffeeShop": "Caffè / Bistrot",
    "caterer": "Catering / Mensa / Associazioni",
    "club": "Club / discoteca",
    "EVENT": "Evento",
    "DEALER": "Mercante",
    "takeAway": "Snack bar / Chiosco / Take-Away",
    "canteen": "Mensa",
    "restaurant": "Ristorante",
    "hotel": "Albergo",
    "spaetshop": "Stazione di servizio / negozio notturno",
    "getraenkehaendler": "Rivenditore di bevande",
    "getraenkeabholmarkt": "Centro di raccolta delle bevande",
    "STAR_GASTRONOMY": "Gastronomia stellata",
    "SYSTEM_GASTRONOMY": "Ristorazione di sistema",
    "spaetShop": "Negozio in ritardo",
    "impress": "Impronta",
    "termsOfUse": "Condizioni di utilizzo",
    "agreeAGB1": "Accetto il",
    "agreeAGB2": "Informativa sulla privacy",
    "agreeAGB3": "a",
    "category": "Categoria",
    "noCategory": "Senza categoria",
    "editTags": "Creare le proprie categorie",
    "selectDeliverer": "Selezionare @:object.deliverer",
    "threeChars": "Inserire almeno tre caratteri per ottenere i risultati della ricerca",
    "offlineMode": "Modalità offline",
    "disable": "disattivare",
    "enable": "attivare",
    "at": "a",
    "atTime": "a",
    "and": "e",
    "customerNo": "Numero cliente",
    "current": "Corrente",
    "tags": "Categorie di filtro",
    "ownCategories": "Categorie proprie",
    "supplierCategories": "Categorie di fornitori",
    "noFilter": "Nessun filtro",
    "quantity": "Quantità",
    "quantityBiggerZero": "Con quantità",
    "or": "o",
    "delivererType": {
      "online": "In linea",
      "offline": "Non in linea"
    },
    "deleted": "Eliminato",
    "resetAmount": "Azzeramento della quantità del prodotto dopo l'ordine",
    "compatibilityMode": "Modalità di compatibilità",
    "timeIssueDelivery": "La data di consegna indicata è già passata. Scegliere una data successiva.",
    "timeIssuePickup": "L'orario di ritiro inserito è già passato. Scegliere una data successiva.",
    "wait": "Attendere prego",
    "day": "Tag",
    "month": "Mese",
    "all": "Tutti",
    "articleNo": "Articolo n.",
    "targetStock": "Quantità target",
    "targetStockShort": "Obiettivo",
    "resetProductQuantity": "Attivando il cursore, la quantità di prodotto viene azzerata dopo la trasmissione dell'ordine. Se non lo si attiva, la quantità di prodotto rimane precompilata per la successiva elaborazione dell'elenco.",
    "offlineMode1": "La modalità offline consente di sincronizzare la lista e di gestirla senza connessione a Internet.",
    "offlineMode2": "Quando si esce dalla modalità offline, tutte le modifiche vengono sincronizzate con il server.",
    "darkMode": "Modalità scura",
    "compatibilityText": {
      "activate": "Attivare questa modalità se si desidera modificare le quantità dei prodotti nell'elenco nell'app, ma effettuare l'ordine tramite il portale web.",
      "webPortal": "Finché questa modalità è attivata, la quantità dell'elenco è sincronizzata con il portale web e non è possibile ordinare l'elenco tramite l'app.",
      "deactivate": "Disattivare questa modalità se si desidera ordinare tramite l'app."
    },
    "newProductSuggestion": "Proposta di un nuovo prodotto",
    "files": "File",
    "issue": "Problemi",
    "place": "Posizione",
    "expectation": "Aspettative",
    "steps": "Passi",
    "availability": "Disponibilità",
    "availableFrom": "Disponibile all'indirizzo",
    "deletedLocations": "Luoghi eliminati",
    "reducedListDesign": "Design a lista ridotta",
    "reducedListDesignDescription": "Il design ridotto dell'elenco modifica la visualizzazione dell'elenco. Le immagini dei prodotti sono nascoste, ma vengono visualizzati altri pulsanti per le operazioni.",
    "insert": "inserire",
    "camera": "Scanner per fotocamera",
    "scanner": "Scanner",
    "picture": {
      "takePicture": "Scattare una foto",
      "selectPicture": "Selezionare l'immagine",
      "editPicture": "Modificare l'immagine",
      "removePicture": "Rimuovi immagine"
    },
    "uncategorized": "Senza categoria",
    "orderDataLoading": "I dati dell'ordine vengono caricati.",
    "screenshot": "Schermata",
    "uploadImage": "Carica immagine",
    "aiCallbackPhone": "Memorizzare il numero di telefono per la richiamata",
    "chat": {
      "roomsEmpty": "Nessuna conversazione",
      "roomEmpty": "Nessuna conversazione selezionata",
      "newMessages": "Nuovi messaggi",
      "messageDeleted": "Messaggio cancellato",
      "messagesEmpty": "Scrivi il tuo primo messaggio",
      "conversationStarted": "Conversazione avviata:",
      "typeMessage": "Scrivi un messaggio…",
      "search": "Cerca"
    }
  },
  "error": {
    "addReminder": "Non è stato possibile assegnare un allarme ordine a un elenco",
    "noMatch": "{target} non corrisponde",
    "notFound": "{target} non è stato trovato. | {target} non è stato trovato.",
    "invalid": "{target} non è corretto. | {target} non è corretto.",
    "empty": "{target} è vuoto. | {target} sono vuoti.",
    "noAuth": "{target} non ha i permessi. | {target} non ha l'autorizzazione.",
    "noAdmin": "Nessun permesso di amministrazione trovato.",
    "addCart": "Non è stato possibile aggiungere un prodotto al carrello. | Non è stato possibile aggiungere il prodotto al carrello.",
    "addPromoPackage": "Il pacchetto promozionale non è stato aggiunto al carrello o è stato aggiunto solo parzialmente.",
    "addList": "Impossibile aggiungere un prodotto all'elenco. | Non è stato possibile aggiungere i prodotti all'elenco.",
    "create": "{target} non può essere creato. | Non è stato possibile creare {target}.",
    "order": "Non è stato possibile elaborare l'ordine.",
    "save": "Non è stato possibile salvare {target}.",
    "delete": "{target} non può essere eliminato.",
    "deleteUser": "Non è stato possibile eliminare l'utente.",
    "resendMail": "Non è stato possibile inviare nuovamente l'e-mail.",
    "sendLink": "Impossibile inviare il link.",
    "removeProduct": "Impossibile rimuovere il prodotto dal carrello. | Non è stato possibile rimuovere il prodotto dal carrello.",
    "registerFalse": "Registrazione fallita.",
    "loginFalse": "Accesso non riuscito.",
    "locationFalse": "Creazione della posizione non riuscita.",
    "orderFinish": "Non è stato possibile creare un ordine.",
    "send": "{target} non può essere inviato.",
    "loadSupplier": "Non è stato possibile caricare il fornitore | Non è stato possibile caricare i fornitori.",
    "loadLists": "Non è stato possibile caricare gli elenchi.",
    "load": "{target} non può essere caricato. | Non è stato possibile caricare {target}.",
    "sendTicket": "Non è stato possibile inviare il feedback.",
    "scanBarcode": "Il codice a barre scansionato non è valido.",
    "promotionLimitReached": "Max. Quantità di azione raggiunta",
    "aiCall": "@:error.returnType.Unknown",
    "ajv": {
      "required": "I campi obbligatori non sono stati compilati",
      "format": "L'input non è corretto: l'input deve essere nel formato {formatInfo}.",
      "formatInfo": {
        "date": "Data",
        "time": "Ora",
        "email": "Email",
        "date-time": "Data e ora"
      },
      "oneOf": "L'input non corrisponde a nessuno dei valori possibili",
      "minimum": "L'input è inferiore al minimo di {min}",
      "maximum": "L'input supera il massimo di {max}",
      "enum": "L'input non contiene uno dei valori possibili"
    },
    "returnType": {
      "Unknown": "Si è verificato un errore",
      "BadRequest": "La richiesta contiene dati errati",
      "NotFound": "La richiesta non ha trovato un elemento.",
      "Unauthorized": "Autorizzazione mancante",
      "Forbidden": "La richiesta non è consentita",
      "NotImplemented": "La richiesta non è implementata",
      "InvalidLogin": "Accesso non valido",
      "InvalidSession": "Sessione non valida",
      "InvalidPassword": "Password non valida",
      "UserNotFound": "Utente non trovato",
      "UserAlreadyExists": "L'utente esiste già",
      "UserEmailAlreadyExists": "Un utente con questa email esiste già",
      "LocationNotFound": "Posizione non trovata",
      "CartItemNotFound": "Prodotto non trovato",
      "ItemAlreadyInCart": "Il prodotto è già presente nel carrello della spesa, modificare la selezione nel carrello della spesa",
      "ListAlreadyInCart": "L'elenco è già presente nel carrello, modificare la selezione nel carrello. L'elenco può essere modificato solo dopo che è stato ordinato nel carrello.",
      "ListCantBeDeleted": "L'elenco non può essere cancellato.",
      "ListEmpty": "L'elenco è vuoto. Controllare se almeno un prodotto ha una quantità superiore a 0.",
      "SupplierNotFound": "Fornitore non trovato",
      "SupplierItemNotFound": "Prodotto del fornitore non trovato",
      "OrderNotFound": "Ordine non trovato",
      "ListNotFound": "Elenco non trovato",
      "ListItemNotFound": "Elenco prodotti non trovato",
      "ItemAlreadyInList": "Il prodotto è già presente nell'elenco, modificare la selezione nell'elenco",
      "ItemNotFromListSupplier": "Il prodotto non proviene dal fornitore di questo elenco",
      "NotificationNotFound": "Notifica non trovata",
      "TagNotFound": "Categoria non trovata",
      "TagAlreadyExists": "La categoria esiste già",
      "UserNotInTeam": "Questo utente non fa parte del team",
      "TokenInvalid": "Il codice inserito non è valido",
      "ReminderNotFound": "Il promemoria dell'ordine non è stato trovato",
      "OwnerCantBeEdited": "Il proprietario non è autorizzato a modificare",
      "PromoCodeInvalid": "Il codice coupon non è valido",
      "PromoCodeInvalidAlreadyExists": "Il codice coupon è già stato utilizzato",
      "QuickStartCodeInvalid": "Il codice Quickstart non è valido",
      "SupplierAlreadyExists": "Il fornitore esiste già",
      "SupplierCustomerInvalid": "La posizione del fornitore non è valida",
      "LocationAlreadyExists": "La posizione esiste già",
      "JavaApiInternalServerError": "Si è verificato un errore",
      "NewsNotFound": "Messaggio non trovato",
      "OrderMessageTooLong": "Il messaggio dell'ordine supera la lunghezza massima",
      "EmailInvalid": "L'e-mail non è valida",
      "TokenInvalidAlreadyUsed": "Il codice inserito è già stato utilizzato",
      "SupplierBlocked": "Il fornitore è bloccato",
      "PromotionExpired": "Articoli promozionali scaduti"
    },
    "scannedProductNotAvailable": "Il prodotto scansionato non è disponibile nel catalogo del vostro fornitore, pertanto non può essere aggiunto all'elenco dello scanner.",
    "scannerNotAvailable": "Il dispositivo non è collegato a uno scanner. Collegarsi a uno scanner o verificare la connessione esistente",
    "chat": {
      "loadMessages": "Impossibile caricare i messaggi",
      "sendMessage": "Impossibile inviare il messaggio",
      "openRoom": "Impossibile aprire la chat",
      "allowedMimeTypes": "Sono ammessi solo file JPG, PNG o PDF",
      "maxSize": "Il file è troppo grande (max. {target} MB)",
      "maxFilesPerMessage": "Massimo {target} file per messaggio"
    }
  },
  "error.": "Si è verificato un errore",
  "target": {
    "username": "Nome utente",
    "user": "Utente",
    "userAndPw": "@:target.username e @:input.password",
    "setting": "Impostazione | Impostazioni",
    "profile": "Profilo",
    "location": "Posizione",
    "order": {
      "paypal": "PayPal"
    },
    "product": "Prodotto | Prodotti",
    "request": "Richiesta",
    "list": "Elenco",
    "required": "Campo obbligatorio",
    "field": "Campo | Campi",
    "deliverer": "Fornitore | Fornitori",
    "tag": "Categoria | Categorie",
    "password": "Password",
    "permission": "Autorizzazione | Permessi"
  },
  "messages": {
    "orderFrom": "Ordine da",
    "mobileWeb": "Abbiamo notato che state cercando di aprire la versione web di Octopus Order da un dispositivo mobile. Per una migliore esperienza d'uso, vi consigliamo di scaricare l'applicazione mobile dal vostro app store sui dispositivi mobili e di utilizzarla al posto della versione web.",
    "mobileWeb2": "I seguenti link vi porteranno all'applicazione mobile di Octopus Order:",
    "setting": {
      "location": "Modifica la tua posizione",
      "profile": "Modifica il tuo profilo utente",
      "delivererAssign": "Assegnare un fornitore alla propria sede",
      "delivererSelect": "Selezionare il fornitore",
      "inputCustomerNr": "Inserire il numero di cliente",
      "changeLocation": "Cambiare la posizione",
      "welcome1": "Salve {name}",
      "welcome2": "Qui si può scegliere",
      "welcome3": "quale rappresentazione preferite"
    },
    "emptyCart": "Siamo spiacenti, il carrello è vuoto.",
    "emptySuggestion": "Siamo spiacenti, al momento non abbiamo proposte di prodotti per lei.",
    "card": {
      "forwardPoints": "Fare clic qui per essere reindirizzati al nostro @:object.pointSystem",
      "points": "Punti Octopus",
      "shop": "Al negozio Octopus",
      "currentPromotion": "Azioni in corso",
      "createLocationExplanation": "Una location può essere un bar, un ristorante, un hotel, un ufficio o un'attività simile.",
      "productSuggestion": "Novità e suggerimenti sui prodotti"
    },
    "noPromotion": "Siamo spiacenti, al momento non abbiamo promozioni per voi.",
    "promotion": {
      "order": "Ordinabile su",
      "octopus": "Promozioni Octopus",
      "deliverer": "Promozioni dai vostri fornitori",
      "articles": "Questi articoli hanno un prezzo speciale al momento"
    },
    "home": {
      "createLocation": "Nuovo @:messages.location.create",
      "welcome1": "Ciao {name}",
      "welcome2": "quale località desidera?",
      "image1": "Miscelato, spillato, ordinato!",
      "image2": "Sicuro, digitale, ordinato!",
      "image3": "Semplice, veloce, consegnato!"
    },
    "dashboard": {
      "catalog": {
        "availableProduct": "Tutti gli articoli disponibili",
        "delivererCatalog": "Assortimento del fornitore",
        "createProduct": "Aggiungi prodotto",
        "createdCustomProduct": "Il prodotto è stato aggiunto all'elenco.",
        "noReducedSupplier": "Attualmente, nessuno dei vostri fornitori offre offerte."
      },
      "home": {
        "orders": "Gli ultimi ordini",
        "favouriteList": "Le ultime liste ordinate",
        "news": "Notizie su Octopus"
      },
      "list": {
        "allLists": "Tutte le liste di questa località",
        "createList": "Nuovo @:titleRoute.addList",
        "noSupplier": "Non avete ancora aggiunto un fornitore alla vostra sede. Aggiungere un fornitore tramite le impostazioni."
      },
      "message": {
        "available": "Notizie disponibili"
      },
      "setting": {
        "order": "Tutto ciò che riguarda i vostri ordini in un colpo d'occhio",
        "team": "Panoramica e gestione del vostro team",
        "deliverer": "Qui potete vedere i vostri fornitori",
        "notification": "Gestite qui le vostre notifiche",
        "display": "Scegliete tra la modalità Scura o Leggera",
        "statistic": "Qui potete visualizzare le vostre valutazioni",
        "imprint": "Informazioni e leggi",
        "support": "Contattare Octopus Order",
        "orderNotificationTimer": "Imposta l'allarme dell'ordine",
        "intro": "Scopri tutte le funzionalità dell'app"
      }
    },
    "location": {
      "thank": "@:button.thank",
      "sendMsg": "Invia un messaggio",
      "create": "Aggiungi posizione",
      "requestSent": "La sua richiesta al fornitore {deliverer} è in fase di revisione. Un rappresentante vi contatterà nei prossimi giorni.",
      "assignDeliverer": "Assegna un fornitore alla tua sede",
      "welcome1": "Salve {name}",
      "intro": "In 4 brevi passi completiamo insieme il tuo profilo"
    },
    "noOrders": "Non hai ancora effettuato alcun ordine.",
    "noOrdersFilter": "Non hai effettuato alcun ordine in questo periodo.",
    "noLists": "Non hai ancora creato nessuna lista.",
    "noNotifications": "Non hai ancora ricevuto notifiche.",
    "noNews": "Siamo spiacenti, al momento non sono disponibili notizie su Octopus.",
    "order": {
      "deliveryType": "Selezionare il metodo di consegna",
      "deliveryTime": "Selezionare il giorno di consegna",
      "pickupTime": "Seleziona l'orario di ritiro",
      "pickup": "Ritiro",
      "delivery": "Consegna",
      "overview": "Panoramica dell'ordine",
      "choosePayment": "Selezionare il metodo di pagamento",
      "redirectPayment": "Nella fase successiva sarete reindirizzati a {target}.",
      "rememberPayment": "Utilizzate il metodo di pagamento per gli ordini futuri.",
      "voucher": "Voucher | Buoni",
      "redeemVoucher": "@:messages.order.voucher redeem",
      "voucherCode": "Inserisci il codice del buono",
      "currentOrders": "I miei ordini",
      "orderProducts": "Il tuo ordine @:oggetto.articolo",
      "otherProducts": "Altri articoli ordinati di frequente",
      "sent": "Il tuo ordine è stato trasmesso con successo a {target}.",
      "locationIssue": "Luogo di ritiro mancante. Inserire un luogo di ritiro."
    },
    "deliverer": {
      "allDeliverers": "Tutti i @:oggetto.consegnatore da {località}",
      "addDeliverer": "Aggiungere un @:oggetto.consegnatore",
      "noEmail": "Aggiungi un indirizzo e-mail al destinatario prima di poter ordinare"
    },
    "team": {
      "invite": {
        "welcome1": "@:messaggi.home.welcome1",
        "welcome2": "Invita altri dipendenti o partner all'app...",
        "copy": "Oppure copiate il codice e condividetelo:",
        "messenger": "Invita direttamente tramite il messenger di tua scelta:",
        "mail": "Tramite indirizzo e-mail",
        "joinTeam": "Unisciti al nostro team",
        "joinTeam2": "Sei stato invitato nella località {location} dell'App Octopus Order!\n\nCon questo link puoi unirti direttamente alla tua squadra.\n\n{inviteLink}\n\nSe non funziona, è possibile accedere all'app con il codice\n\n{link}\n\nper unirsi alla nuova squadra.\n\nPer Android: {appLinkAndroid}\n\nPer IOS: {appLinkIOS}",
        "shareHint": "Per motivi di sicurezza, il codice generato/inviato può invitare solo utenti di base. Per un invito con i diritti selezionati, utilizzare l'invito via e-mail."
      },
      "management": {
        "members": "Membri della squadra di {località}",
        "inviteMember": "Invita i membri del team",
        "addDevice": "Aggiungi dispositivo",
        "permissionExplanation": "Panoramica dei diritti dei nostri ruoli:"
      }
    },
    "missingPermission": "Permesso mancante: {permesso}",
    "missingCartOrderPermission": "Le autorizzazioni nell'app non sono sufficienti. Si prega di contattare il proprietario della località per completare un ordine.",
    "permission": {
      "all": "Tutti i permessi",
      "locationOrderHistoryRead": "Leggere la cronologia degli ordini",
      "locationListRead": "Visualizza gli elenchi",
      "locationListItemRead": "Visualizza i prodotti dell'elenco",
      "locationListItemCreate": "Creare prodotti in elenco",
      "locationListItemUpdate": "Modificare i prodotti dell'elenco",
      "locationListItemDelete": "Cancellare i prodotti dell'elenco",
      "locationListCreate": "Creare elenchi",
      "locationListUpdate": "Modificare gli elenchi",
      "locationListDelete": "Cancellare gli elenchi",
      "locationCartRead": "Visualizza il carrello della spesa",
      "locationCartAdd": "Riempire il carrello",
      "locationCartUpdate": "Modifica i prodotti del carrello",
      "locationCartDelete": "Eliminare i prodotti del carrello",
      "locationOrderCreate": "Creare un ordine",
      "locationOrderRequest": "Eseguire la richiesta d'ordine",
      "locationRead": "Visualizza la posizione",
      "locationCreate": "Creare la posizione",
      "locationUpdate": "Modifica la posizione",
      "locationDelete": "Cancellare una posizione",
      "locationTeamRead": "Visualizza il team",
      "locationTeamMemberAdd": "Aggiungi un membro del team",
      "locationTeamMemberDelete": "Elimina un membro del team",
      "locationTeamMemberRoleUpdate": "Modifica dei ruoli dei membri del team",
      "locationSupplierRead": "Visualizza i fornitori",
      "locationSupplierCreate": "Aggiungi fornitori",
      "meRead": "Leggere i propri dati utente",
      "meUpdate": "Modifica dei propri dati utente",
      "meDelete": "Cancellare il proprio utente",
      "locationListReminderCreate": "Creare un allarme ordine",
      "locationListReminderDelete": "Cancellare l'allarme ordini",
      "locationListReminderRead": "Visualizza allarme ordine",
      "locationListReminderUpdate": "Modifica allarme ordine",
      "locationContactSupplier": "Contatta il fornitore",
      "locationChatRead": "Leggi la chat",
      "locationChatCreate": "Invia messaggi"
    },
    "noListEntries": "Al momento non ci sono articoli in questo elenco",
    "noSearchResults": "Nessun articolo trovato per il tuo filtro",
    "noEntries": "Nessun articolo disponibile",
    "noMail": "Nessuna posta ricevuta",
    "login": {
      "emailSent": "Ti abbiamo appena inviato un'e-mail",
      "setPassword": "Puoi impostare una nuova password tramite il link",
      "resetPassword": "Inserisci il tuo indirizzo e-mail e ricevi una nuova password"
    },
    "start": {
      "notNew": "Già cliente",
      "new": "Prima volta qui"
    },
    "cart": {
      "amount": "{amount} Posizioni dell'articolo",
      "selectionFrom": "Selezione presso il {deliverer}",
      "fromList": "Dalle vostre liste",
      "noList": "Senza elenco",
      "lastOrder": "Dall'ultimo ordine",
      "amountItems": "{amount} Articolo singolo",
      "upgradeToPromotion": "Ci siamo quasi! Solo {amount} Pezzi fino al {shortTitle} Azione 🏷️ → ordina ora",
      "convertToPromotion": "Azione protetta 🏷️ → attiva ora"
    },
    "register": {
      "intro": "Per creare il vostro profilo abbiamo bisogno di alcune informazioni",
      "thank": "Grazie {name}",
      "emailSent": "@:messages.login.emailSent",
      "validate": "Si prega di confermare il proprio account tramite il link",
      "validateEmail": "@:{'messages.register.validate'} inviato al tuo indirizzo e-mail prima di poter ordinare",
      "noCode": "Non ho un codice di invito",
      "code": "Ho ricevuto un codice di invito",
      "skipEmail": "Purtroppo non siamo riusciti a trovare l'indirizzo e-mail inserito. La preghiamo di confermare nuovamente il suo indirizzo e-mail."
    },
    "didYouMean": "Stai cercando {target} per caso?",
    "didYouCheck": "Hai cercato tutti i fornitori nella vista precedente?",
    "agbRequired": "Devi accettare l'informativa sulla privacy.",
    "list": {
      "repeatEach1": "Promemoria",
      "repeatEach2": "Tutti",
      "noTags": "Non sono disponibili categorie di filtro. Aggiungere categorie ai prodotti dell'elenco.",
      "overrideCartList": "L'elenco è già presente nel carrello. Volete sovrascrivere il vostro carrello?",
      "overrideProductList": "Questo prodotto è già presente nel suo carrello. Vuoi sovrascrivere il tuo carrello?",
      "noReminder": "Non sono ancora stati creati allarmi d'ordine per questa lista.",
      "amountReset": "Le quantità dei prodotti sono state ripristinate.",
      "resetCheck": "Siete sicuri di voler azzerare tutte le quantità di questo elenco?"
    },
    "pressEnter": "Confermare sulla tastiera per aggiungere",
    "changedEmail": "Abbiamo appena inviato un'e-mail al nuovo indirizzo. Per applicare la modifica, cliccare sul link inviato.",
    "updateLoading": "L'aggiornamento è in fase di installazione",
    "intro": {
      "home": {
        "msg1": "Cliccate sull'intestazione per tornare alla panoramica della vostra posizione e al carrello degli acquisti.",
        "title1": "Raggiungete le vostre sedi e il carrello degli acquisti",
        "msg2": "Gli ordini più recenti e gli elenchi degli ordini più frequenti sono accessibili direttamente dalla dashboard.",
        "title2": "Panoramica delle vostre attività",
        "msg3": "Utilizzate la barra dei menu per raggiungere la vostra destinazione con un solo clic.",
        "title3": "Navigazione accessibile ovunque"
      },
      "list": {
        "title1": "L'ordine inizia qui",
        "msg1": "Potete accedere ai vostri elenchi e al catalogo tramite l'intestazione. Qui potete cercare gli articoli dei vostri fornitori.",
        "title2": "I vostri fornitori",
        "msg2": "Qui potete visualizzare e modificare gli elenchi degli ordini dei vostri fornitori o crearne di nuovi.",
        "title3": "Ordina ed elimina",
        "msg3": "Tocca l'immagine del prodotto per selezionare uno o più articoli, spostarli con il drag & drop o eliminarli tramite l'icona del cestino.",
        "title4": "Personalizzare facilmente l'elenco",
        "msg4": "La quantità di un prodotto può essere modificata tramite i tasti più e meno. Scorri verso destra per rimuovere il prodotto dall'elenco.",
        "title5": "Trovare rapidamente gli articoli",
        "msg5": "Nel catalogo potete visualizzare e cercare i singoli articoli dei vostri fornitori e filtrarli per categoria."
      },
      "promotion": {
        "title1": "Promozioni e suggerimenti",
        "msg1": "Qui potete vedere le promozioni in corso, i suggerimenti sui prodotti o le novità dei vostri fornitori o di Octopus Order.",
        "title2": "Offerte promozionali dei vostri fornitori",
        "msg2": "Qui potete vedere gli articoli dei vostri fornitori per i quali sono attualmente disponibili offerte speciali.",
        "title3": "Suggerimenti e notizie attuali",
        "msg3": "Con i suggerimenti sui prodotti si ottengono informazioni sulle ultime tendenze dell'industria delle bevande. Nella sezione notizie potete scoprire tutte le ultime novità di Octopus."
      },
      "setting": {
        "msg1": "Qui è possibile gestire i fornitori e le sedi, effettuare impostazioni, visualizzare gli ordini o contattare l'assistenza.",
        "title1": "Impostazioni dell'app",
        "msg2": "Qui potete impostare degli allarmi per ricordarvi regolarmente di ordinare la vostra lista.",
        "title2": "Non dimenticate mai più un ordine",
        "msg3": "Qui potete gestire il vostro team e invitare altri membri del team a Octopus Order.",
        "title3": "Il vostro team",
        "msg4": "Qui avete una panoramica di tutti i vostri fornitori e potete modificarli, rimuoverli e aggiungere nuovi fornitori.",
        "title4": "Panoramica dei fornitori"
      }
    },
    "ordering": "Ordine in corso di esecuzione",
    "noConnection1": "Nessuna connessione al server",
    "noConnection2": "Controllare la connessione a Internet",
    "switchLocation": "La notifica appartiene a un'altra località. Volete cambiare posizione?",
    "containsExpiredPromotion": "Nel carrello è presente un articolo promozionale scaduto. Si prega di rimuoverlo per procedere con l'ordine.",
    "addProductsViaScanner": "Aggiungere prodotti tramite scanner",
    "scanDesiredProducts": "Eseguire la scansione dei prodotti desiderati",
    "scanToAddMoreProducts": "Scansione per aggiungere altri prodotti",
    "updateScanItems": "Si desidera aggiungere gli articoli scansionati all'elenco? Il numero di articoli presenti nell'elenco verrà sovrascritto.",
    "addScanItems": "Volete aggiungere gli articoli scansionati al carrello?",
    "holidayDeliveryTitle": "Il giorno di consegna selezionato è un giorno festivo!",
    "holidayDelivery": "Chiedete al vostro fornitore la data di consegna esatta.",
    "longOrder": "L'ordine è stato effettuato con più di sette giorni di anticipo. Vuoi davvero ordinare a {date}?",
    "cartDataMissing": "Dati dell'ordine non corretti",
    "newBinaryVersion": "È disponibile una nuova versione che contiene importanti modifiche. Si prega di aggiornare la propria versione.",
    "deliveryDayWarningTitle": "La data selezionata non è un giorno di consegna regolare!",
    "deliveryDayWarning": "Si prega di chiarire in anticipo con il fornitore i casi eccezionali.",
    "holidayPickupTitle": "Il giorno di raccolta selezionato è un giorno festivo!",
    "holidayPickup": "Chiedete al vostro fornitore la data esatta di ritiro.",
    "modal": {
      "updateLocationTypeTitle": "La vostra scelta, il vostro vantaggio",
      "updateLocationTypeDescription": "Quando selezionate la vostra attività di ristorazione, personalizziamo per voi contenuti e promozioni. Potete modificare questa impostazione in qualsiasi momento.",
      "updateLocationTypeHint": "La selezione viene utilizzata solo all'interno dell'app e può essere personalizzata in qualsiasi momento."
    },
    "currentLocation": "Siete attualmente nella posizione"
  },
  "object": {
    "order": "Ordine | Ordini",
    "article": "Posizioni degli articoli",
    "promotion": "Azione | Azioni",
    "location": "Posizione",
    "cart": "Carrello della spesa",
    "list": "Elenco | Elenchi",
    "filter": "Filtro",
    "message": "Notizie | Notizie",
    "catalog": "Catalogo",
    "notification": "Notifiche | Notifiche",
    "notificationOption": "@:object.notification{'soptions'}",
    "setting": "Impostazioni",
    "intro": "Apptour",
    "home": "Casa",
    "dark": "Buio",
    "light": "Luce",
    "zip": "CAP",
    "city": "Città",
    "street": "Via",
    "lastname": "Nome",
    "firstname": "Nome",
    "address": "Indirizzo",
    "zipCity": "@oggetto:zip, @oggetto:città",
    "profile": "Profilo",
    "pointSystem": "Sistema di punti",
    "amount": "Quantità",
    "price": "Prezzo unitario",
    "total": "Prezzo totale",
    "notAvailable": "Informazioni sul prezzo non disponibili",
    "sort": "Ordinamento",
    "alphabetic": "Alfabetico",
    "filterCategory": "@:object.filter{'category'}",
    "priceRange": "Fascia di prezzo",
    "team": "Squadra",
    "deliverer": "Fornitore | Fornitori",
    "display": "Opzioni di visualizzazione",
    "statistic": "Statistiche",
    "imprint": "Impronta",
    "law": "Legale",
    "support": "Supporto per gli ordini Octopus",
    "filterOption": {
      "spirits": "Spiriti",
      "nonAlcoholic": "Bevande analcoliche",
      "beer": "Birra",
      "gastro": "Esigenze gastronomiche",
      "wine": "Vino",
      "food": "Cibo",
      "nonFood": "Non cibo",
      "other": "Altro"
    },
    "suggestion": "Prodotto{suggerimento} | Prodotto{suggerimento}",
    "news": "Notizie",
    "days": "Giorni | Giorno",
    "hours": "Ore | Ora",
    "minutes": "Minuti | Minuto",
    "validFor": "Valido per {valore}",
    "validUntil": "Valido fino a",
    "expired": "Scaduto",
    "totalPosition": "Posizione totale",
    "totalOrder": "Valore totale dell'ordine"
  },
  "enumT": {
    "pinned": "Appuntato",
    "new": "Nuovo",
    "restocked": "Di nuovo disponibile",
    "reduced": "In offerta",
    "notInStock": "Con tempi di consegna",
    "promotion": "Articoli promozionali",
    "issueType": {
      "bug": "Bug",
      "feature": "Caratteristica"
    },
    "contactWay": {
      "none": "Si prega di non contattare\n\nEmail",
      "email": "Telefono\n\nEmail o telefono",
      "phone": "Come possiamo contattarla per domande e aggiornamenti?",
      "emailOrPhone": "Email o telefono"
    },
    "sortDirection": {
      "asc": "Alfabetico ascendente",
      "desc": "Alfabetico discendente",
      "catFilter": "Per categoria propria",
      "catSupplier": "Per categoria di fornitori",
      "manually": "Smistamento manuale"
    },
    "weekday": {
      "mon": "Lunedì",
      "tue": "Martedì",
      "wed": "Mercoledì",
      "thu": "Giovedì",
      "fri": "Venerdì",
      "sat": "Sabato",
      "sun": "Domenica"
    },
    "repeatCycle": {
      "once": "unico",
      "week": "settimanale",
      "month": "mensile",
      "appendix": {
        "week": "settimana/e",
        "month": "mese(i)"
      }
    },
    "month": {
      "january": "Gennaio",
      "february": "Febbraio",
      "march": "Marzo",
      "april": "Aprile",
      "may": "Maggio",
      "june": "Giugno",
      "july": "Luglio",
      "august": "Agosto",
      "september": "Settembre",
      "october": "Ottobre",
      "november": "Novembre",
      "december": "Dicembre"
    }
  },
  "modal": {
    "selection": "Scelte",
    "addList": "Aggiungi alla lista",
    "addCart": "Aggiungi al carrello",
    "openCatalog": "Aprire il catalogo"
  },
  "success": {
    "addReminder": "Ordine sveglia è stato aggiunto",
    "editReminder": "Ordine sveglia salvato",
    "deleteReminder": "La sveglia dell'ordine è stata cancellata",
    "addCart": "Il prodotto è stato aggiunto al carrello. | Il prodotto è stato aggiunto al carrello",
    "addPromoPackage": "Pacchetto promozionale è stato aggiunto al carrello.",
    "addCartNumber": "{target} Singoli articoli da {target2} posizioni di articoli sono stati aggiunti al carrello",
    "addList": "Il prodotto è stato aggiunto all'elenco. | I prodotti sono stati aggiunti all'elenco.",
    "order": "L'elenco è stato ordinato.",
    "save": "{target} è stato salvato con successo. | {target} è stato salvato con successo.",
    "resendMail": "L'e-mail è stata reinviata.",
    "copyLink": "Il link è stato copiato",
    "sendLink": "Il link è stato inviato.",
    "removeProduct": "Il prodotto è stato rimosso dal carrello. | Il prodotto è stato rimosso dal carrello.",
    "orderFinish": "L'ordine è stato creato.",
    "delete": "{target} è stato eliminato.",
    "deleteUser": "L'utente è stato cancellato",
    "deleteMulti": "{amount} {target} è stato cancellato.",
    "send": "{target} è stato inviato.",
    "create": "{target} è stato creato.",
    "edit": "{target} è stato modificato con successo.",
    "add": "{target} è stato aggiunto.",
    "deleteTeam": "L'utente è stato rimosso dal team.",
    "setRole": "Il ruolo dell'utente è stato impostato con successo",
    "joinLocation": "La posizione è stata aggiunta con successo",
    "sendInvite": "L'e-mail di invito è stata inviata.",
    "sendTicket": "Abbiamo ricevuto il vostro feedback. Grazie mille.",
    "aiCall": "L'Octobot vi chiamerà a breve."
  },
  "success.": "Campagna riuscita",
  "alert": {
    "delete": {
      "account": "Desideri cancellare definitivamente il tuo account e tutte le località associate?",
      "reminder": "Vuoi davvero cancellare questo allarme ordine?",
      "location": "Vuoi davvero cancellare questa posizione?",
      "list": "Si vuole davvero cancellare l'elenco \"{target}\"?",
      "noList": "Vuoi rimuovere tutti i prodotti dal tuo carrello?",
      "cartSupplier": "Vuoi svuotare il carrello a \"{target}\"?",
      "cartProduct": "Si vuole davvero eliminare il prodotto \"{target}\" dal carrello?",
      "cartList": "Si desidera davvero rimuovere l'elenco \"{target}\" e tutti gli articoli correlati dal carrello?",
      "product": "Si desidera davvero eliminare il prodotto \"{target}\" dall'elenco? | Si desidera davvero eliminare i prodotti selezionati dall'elenco?",
      "supplier": "Volete rimuovere {name} dai vostri fornitori? Attenzione: la rimozione di un fornitore rimuove anche tutti gli elenchi di questo fornitore.",
      "member": "Si desidera davvero rimuovere {target}\" dal team?",
      "tag": "Volete davvero rimuovere \"{target}\" dalle vostre categorie?",
      "customSupplier": "Vuoi davvero eliminare questo fornitore?",
      "scanProduct": "Si desidera rimuovere il prodotto \"{target}\" dagli articoli scansionati?"
    },
    "delivererSuccess": "Il fornitore è stato aggiunto con successo",
    "delivererError": "Errore",
    "delivererSuccessMessage": "Abbiamo aggiunto {target} alla vostra posizione.",
    "delivererErrorMessage": "Non è stato possibile aggiungere {target} alla vostra posizione. Controllare i dati inseriti.",
    "selectList": "Scegliere un elenco",
    "selectSupplier": "Scegliere un fornitore",
    "noList": "Nessun elenco disponibile per questo fornitore.",
    "noSupplier": "Nessun fornitore disponibile per questo articolo",
    "discardFormTitle": "Attenzione!",
    "noInternet": "Non è stato possibile sincronizzare tutti i dati offline. Controllare la connessione a Internet.",
    "compatibilityMode": "È stata attivata la modalità di compatibilità. Finché è attiva, è possibile ordinare solo tramite il portale web. La quantità specificata è ora nel carrello. Se si desidera ordinare tramite l'app, disattivare questa modalità nelle impostazioni della lista.",
    "discardForm": "I vostri dati non verranno salvati. Lasciare comunque la pagina?",
    "syncing": "Gli elenchi sono sincronizzati",
    "logout": "Vuoi davvero cancellarti?",
    "upgradeToPromotion": "Utilizzare subito la promozione? La quantità viene regolata automaticamente alla quantità minima ({target})",
    "convertToPromotion1": "Applicare l'azione?",
    "convertToPromotion2": "{target1} Oggetto promozionale, {target2} normale",
    "orderAmountOverLimit": "Limite raggiunto: {isAmount} Articolo promozionale nel carrello. Massimo +{availableAmount} possibile",
    "scannerNotActivated": "La funzione scanner non è attualmente supportata dai vostri fornitori!",
    "scannerAvailableOnlyInApp": "La funzione scanner è disponibile solo nell'app!",
    "addLastOrderToCart": "Vuoi aggiungere nuovamente al carrello tutti gli articoli e le quantità del tuo ultimo ordine?"
  },
  "titleRoute": {
    "locationData": "Creare una posizione",
    "locationCreate": "@:titleRoute.locationData",
    "locationDeliverer": "Selezionare il fornitore",
    "locationAdd": "Aggiungi località",
    "locationJoin": "Unirsi alla posizione",
    "addLocationDeliverer": "Aggiungi fornitore",
    "editLocationDeliverer": "Modifica fornitore",
    "settingProfile": "Profilo",
    "settingLocation": "Modifica la posizione",
    "settingOrder": "Ordine | Ordini",
    "settingOrderDetail": "Dettagli dell'ordine",
    "settingTeam": "Squadra",
    "settingTeamInvite": "Invita la squadra",
    "settingDeliverer": "Fornitori",
    "settingDelivererSelect": "Scegliere il fornitore",
    "settingNotification": "Notifiche",
    "settingDisplay": "Opzioni di visualizzazione",
    "settingSupport": "Supporto",
    "settingLegal": "Legale",
    "cart": "Carrello",
    "orders": "Ordini",
    "filter": "Filtro",
    "addList": "Crea elenco",
    "editList": "Modifica elenco",
    "notificationDetails": "@:titleRoute.settingNotification",
    "orderNotificationTimer": "Ordine di allarme",
    "changePassword": "Modifica della password",
    "addProduct": "Aggiungi prodotto",
    "editProduct": "Modifica del prodotto",
    "agb": "Informativa sulla privacy",
    "news": "Notizie su Octopus",
    "suggestion": "Proposta di prodotto",
    "productDetails": "Dettagli sul prodotto",
    "promotionDetails": "Dettagli dell'azione",
    "productPresentation": "@:titleRoute.productDetails",
    "promotion": "@:titleRoute.promotionDetails",
    "settingIntro": "Apptour",
    "feedback": "Creare un feedback",
    "scanner": "Scanner",
    "skipEmail": "Verifica dell'e-mail",
    "deleteLocations": "Luoghi cancellati",
    "aiCall": "Ordine AI"
  },
  "placeholder": {
    "search": "Ricerca",
    "selectSize": "Seleziona la dimensione",
    "selectVariant": "Selezionare la variante",
    "location": {
      "name": "Nome della località",
      "type": "Tipo di località",
      "zip": "Codice postale",
      "ownZip": "Codice postale della propria località",
      "city": "Città",
      "street": "Via",
      "streetNumber": "No.",
      "phone": "Numero di telefono",
      "internationalPhone": "Numero di telefono internazionale",
      "deliverer": "@:selezionare oggetto.consegnatario",
      "customerNumber": "@:label.customerNumber inserire"
    },
    "email": "Email",
    "newEmail": "Nuova e-mail",
    "oldPassword": "Vecchio @:input.password",
    "password": "@:input.password",
    "passwordRepeat": "@:input.password ripetere",
    "sendMessageDeliverer": "Invia un messaggio a {deliverer} ...",
    "inviteCode": "Inserire il codice di invito",
    "firstName": "@:label.firstName",
    "lastName": "@:label.lastName",
    "name": "Nome",
    "phone": "@:placeholder.location.phone",
    "street": "Via",
    "zip": "CAP",
    "city": "Città",
    "alphabetic": "Alfabetico",
    "customerNumber": "Numero cliente",
    "customerNumberPlus": "Numero del cliente/numero del punto vendita",
    "quickstart": "Codice di avvio rapido",
    "paymentMethod": "Metodo di pagamento",
    "pickupMethod": "Posizione",
    "deliveryDate": "Data di consegna",
    "emailOrPhone": "@:segnaposto.email",
    "code": "Codice invito",
    "packaging": "Dimensione del pacchetto",
    "searchOrAdd": "Cerca o aggiungi una categoria",
    "tagName": "Nome della categoria",
    "pickupLocation": "Raccogli in",
    "pickupDate": "Orario di ritiro",
    "quantity": "Quantità",
    "eancode": "Codice EAN",
    "customSupplierType": "Tipo di fornitore",
    "issueType": "Tipo di feedback",
    "title": "Titolo",
    "bug": {
      "issue": "Qual è il problema?",
      "place": "Dove si verifica il problema?",
      "expectation": "Quale comportamento vi aspettereste al posto di quello attuale?",
      "steps": "Quali passi sono stati compiuti prima che si verificasse il bug? / Come si può riprodurre il bug?"
    },
    "feature": {
      "expectation": "Quale funzione aggiuntiva vorreste vedere?",
      "place": "Dove manca la funzione desiderata?"
    },
    "select": "Selezionare",
    "contactWay": "Come possiamo contattarvi per domande e aggiornamenti?"
  },
  "option": {
    "industry": {
      "PRIVATE": "Privato",
      "GETRAENKEFACHGROSSHANDEL": "Vendita all'ingrosso di bevande",
      "LEBENSMITTEL_GROSSHANDEL": "Ingrosso di prodotti alimentari",
      "HANDELSWAREN_ALLGEMEIN": "Merceologia generale",
      "SONSTIGE": "Altro"
    },
    "customSupplierType": {
      "meat": "Fornitore di carne",
      "vegetable": "Verdura",
      "drinks": "Bevande",
      "hygiene": "Articoli per l'igiene",
      "other": "Altro"
    }
  }
}

export default it;